// Recorrido guiado del Técnico (Tareas del Día). Se abre con el botón "?".
// Mientras dura, TechnicianDashboard reemplaza la lista por una tarea de ejemplo (TOUR_DEMO_TASK)
// en el estado del paso (demoStatus), y abre sus ventanas de ejemplo según `modal`:
//   'details' → detalle de la tarea; 'form-<tipo>' → vista previa del formulario (TOUR_DEMO_FORMS).
// appears: la tarea y sus ventanas de ejemplo se dibujan al aplicar el paso (useGuidedTour no los descarta).
// Nada de esto llama al backend: avanzar por los pasos no cambia estados ni envía formularios.
const target = (id) => `[data-tour="${id}"]`;
const TASKS = 'Tareas del día';
const DETAIL = 'Detalle';
const WORK = 'Ejecución';
const FORM = 'Formulario general';
const FINISH = 'Finalización';
const CANCEL = 'Cancelación';

export const TOUR_DEMO_TASK = {
  id: 'tour-demo-task',
  title: 'Instalación del servicio (ejemplo)',
  taskTypeName: 'Instalación',
  priority: 'media',
  description: 'Instalar el equipo y verificar el funcionamiento del servicio en el domicilio.',
  client: {
    name: 'Cliente de ejemplo',
    phone: '000 000 0000',
    address: 'Calle de ejemplo 123',
  },
};

const OBSERVATIONS = { id: 'observations', name: 'observations', label: 'Observaciones', type: 'textarea', placeholder: 'Comentarios adicionales' };

// Campos de muestra: los reales los configura el administrador en Formularios.
export const TOUR_DEMO_FORMS = {
  general: {
    title: 'Información General - Cliente de ejemplo',
    submitText: 'Guardar e Iniciar',
    fields: [
      { id: 'medicion', name: 'medicion', label: 'Medición inicial', type: 'number', required: true, placeholder: 'Ej.: 45' },
      { id: 'fotos', name: 'fotos', label: 'Fotos del lugar', type: 'image', required: true },
      OBSERVATIONS,
    ],
  },
  finalizacion: {
    title: 'Finalizar Tarea - Cliente de ejemplo',
    submitText: 'Finalizar Tarea',
    fields: [
      { id: 'trabajo_realizado', name: 'trabajo_realizado', label: 'Trabajo realizado', type: 'textarea', required: true, placeholder: 'Detalle del trabajo' },
      { id: 'fotos_finales', name: 'fotos_finales', label: 'Fotos del trabajo terminado', type: 'image', required: true },
      OBSERVATIONS,
    ],
  },
  cancelacion: {
    title: 'Cancelar Tarea - Cliente de ejemplo',
    submitText: 'Confirmar Cancelación',
    fields: [
      { id: 'motivo', name: 'motivo', label: 'Motivo', type: 'select', required: true, options: ['Cliente ausente', 'Domicilio inaccesible', 'Faltan materiales'] },
      { id: 'requiresReschedule', name: 'requiresReschedule', label: 'Requiere reagenda', type: 'checkbox', required: true },
      { id: 'withVisit', name: 'withVisit', label: 'Con visita?', type: 'checkbox', required: true },
      OBSERVATIONS,
    ],
  },
};

export const technicianTour = [
  {
    phase: TASKS, center: true, nextText: 'Empezar recorrido', prevText: 'Ahora no',
    title: 'Ejecución de tareas',
    text: 'Te mostramos dónde consultar tus tareas asignadas y cómo registrar cada etapa del trabajo, desde que sales hacia el cliente hasta que finalizas o cancelas la tarea.',
    note: 'Durante el recorrido se muestra una tarea de ejemplo: nada de lo que se señala cambia tus tareas reales.',
  },
  { phase: TASKS, element: target('tech-nav'), sidebar: true, title: 'Menú',
    text: '«Tareas del Día» muestra el trabajo asignado para hoy. «Historial» permite consultar las tareas realizadas, aplicar distintos filtros y ver el detalle de cada una con las respuestas de sus formularios.' },
  { phase: TASKS, element: target('tech-stats'), title: 'Resumen del día',
    text: 'Total de tareas del día y cuántas están pendientes, en camino y completadas.' },
  { phase: TASKS, appears: true, element: target('tech-task-card'), title: 'Tarjeta de tarea',
    text: 'Cada tarjeta es una tarea asignada. El número indica su orden en el recorrido del día; las tareas finalizadas o canceladas dejan de mostrarse en la lista.' },
  { phase: TASKS, appears: true, element: target('tech-task-status'), title: 'Estado',
    text: 'Indica en qué etapa está la tarea: Pendiente, En camino, Iniciada o Relevada. Los botones de la tarjeta cambian según el estado.' },
  { phase: TASKS, appears: true, element: target('tech-task-client'), title: 'Cliente y prioridad',
    text: 'Nombre y teléfonos del cliente (el ícono copia el número) y la prioridad de la tarea.' },
  { phase: DETAIL, appears: true, element: target('tech-task-details'), title: 'Abrir el detalle',
    text: '«Detalles» muestra la información completa de la tarea. Está disponible en cualquier estado.' },
  { phase: WORK, appears: true, element: target('tech-action-en-camino'), title: 'En camino',
    text: 'Registra que el técnico sale hacia el cliente. Pide confirmación y envía un aviso al cliente. Desde este estado se muestran la dirección y el acceso a Google Maps.',
    note: 'Solo puede haber una tarea activa a la vez: mientras otra esté En camino, Iniciada o Relevada, este botón no aparece.' },
  { phase: DETAIL, modal: 'details', demoStatus: 'en_camino', appears: true, element: target('tech-details'), title: 'Detalle de la tarea',
    text: 'Título, teléfonos, descripción del trabajo y dirección del cliente. «Google Maps» abre la navegación hasta el domicilio.' },
  { phase: DETAIL, modal: 'details', demoStatus: 'en_camino', appears: true, element: target('tech-details-documents'), title: 'Documentos',
    text: 'Lista los archivos que la empresa compartió para esta tarea (planos, órdenes, instructivos) y permite descargarlos.' },
  { phase: WORK, demoStatus: 'en_camino', appears: true, element: target('tech-action-start'), title: 'Iniciar',
    text: 'Al llegar al domicilio, registra el comienzo del trabajo y la tarea pasa a Iniciada.',
    note: 'Desde En camino también está disponible «Cancelar».' },
  { phase: WORK, demoStatus: 'iniciada', appears: true, element: target('tech-task-timer'), title: 'Tiempo transcurrido',
    text: 'Con la tarea Iniciada o Relevada, la tarjeta muestra el tiempo de trabajo desde el inicio.' },
  { phase: FORM, demoStatus: 'iniciada', appears: true, element: target('tech-action-form'), title: 'Formulario general',
    text: 'Si el tipo de tarea tiene un formulario general, este botón aparece en lugar de «Finalizar» y debe completarse primero. Si no lo tiene, «Finalizar» aparece directamente.' },
  { phase: FORM, modal: 'form-general', demoStatus: 'iniciada', appears: true, element: target('tech-form'), title: 'Completar el formulario',
    text: 'Contiene los datos que solicita la empresa para este tipo de tarea. Al enviarlo con «Guardar e Iniciar», la tarea pasa a Relevada.',
    note: 'Mientras se completa, el borrador se guarda en el dispositivo: si el formulario se cierra , los datos se conservan.' },
  { phase: FORM, modal: 'form-general', demoStatus: 'iniciada', appears: true, element: target('tech-form-required'), title: 'Campos obligatorios',
    text: 'Los campos marcados con * son obligatorios. Si falta alguno, el formulario no se envía y un aviso indica cuál completar.' },
  { phase: FORM, modal: 'form-general', demoStatus: 'iniciada', appears: true, element: target('tech-form-images'), title: 'Imágenes y evidencias',
    text: 'Permite adjuntar fotos desde la cámara o la galería. Las imágenes se comprimen automáticamente, se pueden quitar antes de enviar y se suben al enviar el formulario.',
    note: 'Cada envío admite hasta 20 imágenes.' },
  { phase: FINISH, demoStatus: 'relevada', appears: true, element: target('tech-action-finish'), title: 'Finalizar',
    text: 'Con la tarea Relevada (o Iniciada, si no hay formulario general), «Finalizar» abre el formulario de finalización.' },
  { phase: FINISH, modal: 'form-finalizacion', demoStatus: 'relevada', appears: true, element: target('tech-form'), title: 'Formulario de finalización',
    text: 'Registra el resultado del trabajo. Al enviarlo con «Finalizar Tarea», la tarea pasa a Finalizada y sale de la lista.',
    note: 'Si el tipo de tarea no tiene un formulario de finalización configurado, se muestra un aviso.' },
  { phase: CANCEL, demoStatus: 'relevada', appears: true, element: target('tech-action-cancel'), title: 'Cancelar',
    text: 'Se utiliza cuando el trabajo no puede completarse. Está disponible con la tarea En camino, Iniciada o Relevada y abre el formulario de cancelación.' },
  { phase: CANCEL, modal: 'form-cancelacion', demoStatus: 'relevada', appears: true, element: target('tech-form'), title: 'Formulario de cancelación',
    text: 'Registra el motivo con los campos que configuró la empresa. «Requiere reagenda» indica si la tarea debe reprogramarse y «Con visita?», si llegaste a visitar al cliente. Al enviarlo con «Confirmar Cancelación», la tarea pasa a Cancelada.' },
  { phase: 'Recorrido', element: target('tech-map'), title: 'Mapa y recorrido',
    text: 'Muestra el recorrido confirmado del día con las paradas numeradas y la base operativa (B).',
    note: 'Al marcar En camino o iniciar una tarea fuera del orden previsto, el recorrido se recalcula desde esa tarea.' },
];
